import './redactor.min'
import './plugins/alignment/alignment.min'
import './plugins/definedlinks/definedlinks.min'
import './plugins/fontcolor/fontcolor.min'
import './plugins/fontfamily/fontfamily.min'
import './plugins/fontsize/fontsize.min'
import './plugins/fullscreen/fullscreen.min'
import './plugins/imagemanager/imagemanager.min'
import './plugins/specialchars/specialchars.min'
import './plugins/table/table.min'
import './plugins/textdirection/textdirection.min'
import './plugins/video/video.min'

init_redactor = function () {
  function generateCSRF() {
    var csrf_token = $("meta[name=csrf-token]").attr("content");
    var csrf_param = $("meta[name=csrf-param]").attr("content");
    var params;
    if (csrf_param !== undefined && csrf_token !== undefined) {
      params = csrf_param + "=" + encodeURIComponent(csrf_token);
    }
    return params;
  }

  imageUploadURL = "/redactor/image_upload?" + generateCSRF();

  $R(".redactor", {
    plugins: ["fontcolor", "fontsize", "alignment", "fullscreen", "table", "video"],
    buttons: [
      "format",
      "redo",
      "undo",
      "fontcolor",
      "fontsize",
      "bold",
      "italic",
      "underline",
      "deleted",
      "lists",
      "table",
      "image",
      "link",
      "alignment",
      "html",
      "video"
    ],
    formatting: ["p", "blockquote"],
    imageUpload: imageUploadURL,
    imagePosition: true,
    imageResizable: true,
    lang: "fr"
  });
};

$(document).ready(init_redactor);

$(document).on('has_many_add:after', init_redactor);
